import React from "react";

function SendIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="35"
      fill="none"
      viewBox="0 0 34 35"
    >
      <path
        stroke="#F0B595"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M32 2.464l-16.5 17.05M32 2.464l-10.5 31-6-13.95-13.5-6.2 30-10.85z"
      ></path>
    </svg>
  );
}

export default SendIcon;
